import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { BaseTable } from 'app/components/common/BaseTable'
import {
  BORDER_RADIUS,
  FONT_SIZE,
  FONT_WEIGHT,
  PADDING,
  colors,
} from 'parkway-web-common'
import styled from 'styled-components'

const MAX_CHILDREN_SIZE = 20

export const BaseReportWrapper = styled.div`
  padding: 8px;
`

export const BaseTableWrapper = styled(BaseTable)`
  ${() => {
    let styles = ''
    for (let i = 1; i <= MAX_CHILDREN_SIZE; i++) {
      styles += `
        .ant-table-row.ant-table-row-level-${i} .ant-table-cell {
          background-color: #F9FAFB !important;
        }
      `
    }
    return styles
  }}

  & .ant-pagination-item {
    border-radius: ${BORDER_RADIUS};
    min-width: 1.75rem;
    height: 1.75rem;
    line-height: 1.75rem;
  }

  .row-overwrite-style {
    .ant-table-cell {
      border: 0.5px solid var(--neutral-black-2-color);
    }

    .ant-table-cell-row-hover {
      background: white !important;
    }

    .ant-table-cell-row-hover:has(.is-expanded) {
      background: var(--neutral-black-9-color) !important;
    }

    .ant-table-cell-row-hover:has(.is-hight-light) {
      background: var(--neutral-black-9-color) !important;
    }

    .ant-table-cell-row-hover:has(.is-expanded-1) {
      background: var(--neutral-black-16-color) !important;
    }

    .ant-table-cell-row-hover:has(.is-total-group-table) {
      background: var(--states-blue-light-color) !important;
    }

    .ant-table-cell-row-hover:has(.is-total-table) {
      background: var(--neutral-black-9-color) !important;
    }

    .ant-table-cell-row-hover:has(.is-expanded-child) {
      background: var(--neutral-black-1-color) !important;
    }
  }

  .ant-table-thead > tr > th {
    border: 0.5px solid var(--neutral-black-2-color) !important;
    text-align: center !important;
    font-size: 12px !important;
  }

  .very-big-column {
    min-width: 300px !important;
  }

  .big-column {
    min-width: 220px !important;
  }

  .normal-column {
    min-width: 170px !important;
  }

  .medium-column {
    min-width: 100px !important;
  }

  .small-column {
    min-width: 30px !important;
  }

  .number-column {
    min-width: 60px !important;
    max-width: 60px !important;
  }

  .center {
    text-align: center;
  }

  .title {
    &-right {
      text-align-last: right;
      padding-right: 24px;
    }
  }

  .flex-row {
    .ant-row {
      margin-left: 5px;
      display: inline-block;
    }
  }

  .all-column:has(.is-expanded) {
    background-color: var(--neutral-black-9-color);
  }

  .all-column:has(.is-hight-light) {
    background-color: var(--neutral-black-9-color) !important;
  }

  .all-column:has(.is-expanded-1) {
    background-color: var(--neutral-black-16-color);
  }

  .all-column:has(.is-total-group-table) {
    background-color: var(--states-blue-light-color) !important;
  }

  .all-column:has(.is-total-table) {
    background-color: var(--neutral-black-9-color) !important;
  }

  .all-column:has(.is-expanded-child) {
    background-color: var(--neutral-black-1-color);
  }

  .all-column {
    background-color: white;
    padding: 8px !important;
  }

  .money-column {
    min-width: 100px !important;
    text-align: right !important;
  }

  .date-column {
    min-width: 90px !important;
  }

  .index-column {
    min-width: 14px !important;
  }

  .clinic-column {
    min-width: 150px !important;
  }

  .patient-name-column {
    min-width: 160px !important;
  }

  .ant-table-cell {
    padding: 8px !important;
  }

  .phone-column {
    min-width: 102px !important;
  }

  .patient-code-column {
    min-width: 80px !important;
  }

  .ant-table-pagination.ant-pagination {
    margin: 0px !important;
    padding-bottom: 4px !important;
    padding-top: 4px !important;
    padding: 0px !important;

    .ant-pagination-item {
      min-width: 1.5rem;
      height: 1.5rem;
      line-height: 1.4rem;
      font-size: 12px;
    }

    .ant-pagination-jump-next {
      min-width: 1.5rem;
      height: 1.5rem;
      line-height: 1.4rem;
      font-size: 12px;
    }

    .ant-pagination-jump-prev {
      min-width: 1.5rem;
      height: 1.5rem;
      line-height: 1.4rem;
      font-size: 12px;
    }

    .ant-select-single {
      height: 1.55rem;
    }

    .ant-select-single .ant-select-selector {
      font-size: 12px;
      font-weight: 500;
    }

    .ant-pagination-prev {
      min-width: 1.5rem !important;
      height: 1.5rem !important;
      border-radius: 4px !important;
      svg {
        width: 12px;
        height: 12px;
      }
    }

    .ant-pagination-next {
      min-width: 1.5rem !important;
      height: 1.5rem !important;
      border-radius: 4px !important;

      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
`

export const AreaRowWrapper = styled(BaseRow)<{ $isExpanded?: boolean }>`
  width: 100%;
  height: 100%;
  position: ${props => (props?.$isExpanded ? 'absolute' : 'unset')};
  top: ${props => (props?.$isExpanded ? PADDING.md : 'unset')};
`

export const ExpandedNotHaveChildRowWrapper = styled(BaseRow)`
  width: 100%;
`

export const AreaText = styled.div`
  margin-left: ${PADDING.xxs};
  font-weight: ${FONT_WEIGHT.bold};
  width: 80%;

  &.medium-text {
    font-weight: ${FONT_WEIGHT.medium};
  }
`

export const AreaNotExpandedReplaceIcon = styled.div`
  width: 20px;
  height: 20px;
  background-color: transparent;
`

export const RevenueTableWrapper = styled(BaseRow)<{
  $isBold?: boolean
  $isBlueText?: boolean
  colorOverwrite?: string
}>`
  align-item: center;
  font-weight: ${props =>
    props?.$isBold ? FONT_WEIGHT.bold : FONT_WEIGHT?.medium};
  color: ${props => {
    if (props?.colorOverwrite) {
      return props?.colorOverwrite
    }
    return props?.$isBlueText ? '#216AE2' : 'var(--primary-color)'
  }};
`

export const NoWrapper = styled.div`
  position: absolute !important;
  top: ${PADDING.md};
`

export const HeadingTitlePage = styled.p`
  font-size: ${FONT_SIZE.xxl};
  color: var(--primary-color);
  font-weight: ${FONT_WEIGHT.bold};
  padding: ${PADDING.md} 0px;
`

export const RootWrapper = styled(BaseSpace)`
  background-color: ${colors.white};
  padding: 8px;
  border-radius: ${BORDER_RADIUS};
`

export const HeadWrapper = styled(BaseRow)``

export const TitleTable = styled.span`
  font-size: ${FONT_SIZE.xs};
  color: var(--primary-color);
  font-weight: ${FONT_WEIGHT.bold};
`

export const GrowthWrapper = styled(BaseRow)<{ $upValue?: boolean }>`
  background-color: ${props =>
    props?.$upValue
      ? 'var(--states-green-light-color)'
      : ' var(--states-red-light-color)'};
  padding: 1px 2px;
  border-radius: 4px;
  width: fit-content;
  margin-left: ${PADDING.xxxs};

  .value {
    font-size: ${FONT_SIZE.xxs};
    font-weight: ${FONT_WEIGHT.semibold};
    color: ${props =>
      props.$upValue ? 'var(--states-green-color)' : 'var(--states-red-color)'};
    margin-left: ${PADDING.xxxxs};
  }
  width: 92px;
`
